import gql from 'graphql-tag';

import { PlusOneGuest } from 'types/plus-one.types';
import { QuestionResponse } from 'types/question-response.types';

export interface UpdatePlusOneRsvpStatusInput {
  eventId: number;
  gid: string;
  plusOneId: number;
  status: string;
  sendNotifications: boolean;
  questionnaireResponses?: QuestionResponse[];
  ownerQuestionnaireResponses?: QuestionResponse[];
}

export interface UpdatePlusOneRsvpStatusVariables {
  input: UpdatePlusOneRsvpStatusInput;
}

export interface UpdatePlusOneRsvpStatusResponse {
  updatePlusOneRsvpStatus: {
    ok: boolean;
    plusOneGuest: PlusOneGuest;
  };
}

export enum UpdatePlusOneRsvpStatusError {
  PLUS_ONE_GUEST_NOT_FOUND = 'PLUS_ONE_GUEST_NOT_FOUND',
  PLUS_ONES_DISABLED = 'PLUS_ONES_DISABLED',
  OWNER_GUEST_NOT_FOUND = 'OWNER_GUEST_NOT_FOUND',
  OWNER_GUEST_NOT_CONFIRMED = 'OWNER_GUEST_NOT_CONFIRMED',
  INVALID_STATUS_CHANGE = 'INVALID_STATUS_CHANGE',
  EVENT_IS_OVER = 'EVENT_IS_OVER',
  CAPACITY_INCLUDES_PLUS_ONES_DISABLED = 'CAPACITY_INCLUDES_PLUS_ONES_DISABLED'
}

export const UPDATE_PLUS_ONE_RSVP_STATUS_MUTATION = gql`
  mutation updatePlusOneRsvpStatus($input: UpdatePlusOneRsvpStatusInput!) {
    updatePlusOneRsvpStatus(input: $input) {
      ok
      plusOneGuest {
        plusOneId
        eventId
        firstName
        lastName
        status
      }
    }
  }
`;
